import React, { FC, useContext } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { AuthRoute } from '..';
import { StoreProvider, loginStore, resetPassStore, AuthContext } from '../..';
import { getUrlParam } from '../../../common';
import * as urls from '../../../common/constants/urls';
import { LogIn, ResetPass } from '../../../view';

const SystemRoutes: FC = (): JSX.Element => {
	const { token } = useContext(AuthContext);

	return (
		<Switch>
			<AuthRoute exact path='/'>
				<Redirect to={urls.DASHBOARD_URL.value} />
			</AuthRoute>
			{!token && (
				<AuthRoute exact path={urls.LOG_IN_URL.value} nonOuth>
					<StoreProvider store={loginStore} page='login'>
						<LogIn />
					</StoreProvider>
				</AuthRoute>
			)}
			{token && (
				<AuthRoute exact path={urls.LOG_IN_URL.value}>
					<Redirect to={urls.DASHBOARD_URL.value} />
				</AuthRoute>
			)}
			{!!getUrlParam('token') && (
				<Route path={urls.RESET_URL.value}>
					<StoreProvider store={resetPassStore} page='reset'>
						<ResetPass />
					</StoreProvider>
				</Route>
			)}
		</Switch>
	);
};

export { SystemRoutes };
